import React from "react";
import Seo from "../components/Generic/Seo";
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";
import MentorshipHero from "../components/MentorShip/MentorshipHero";
import MentorsSection from "../components/MentorShip/MentorsSection";
import MentorshipFormats from "../components/MentorShip/MentorshipFormats";
import JoinMentorship from "../components/MentorShip/JoinMentorship";
import InViewFade from "../components/Generic/InViewFade";

const MentorShip = () => {
  const seoData = {
    title: "Mentorship - Wise Community",
    description:
      "Join Wise Community's mentorship program to connect with experienced professionals in the semiconductor ecosystem.",
    keywords:
      "Mentorship, Wise Community, semiconductor, women in tech, professional development",
    pathSlug: "mentorship",
  };

  return (
    <>
      <Seo data={seoData} />
      <GoogleAnalytics page={seoData.pathSlug} title={seoData.title} />

      <>
        <InViewFade direction="up">
          <MentorshipHero />
        </InViewFade>

        <InViewFade direction="left">
          <MentorshipFormats />
        </InViewFade>

        <InViewFade direction="right">
          <JoinMentorship />
        </InViewFade>

        <InViewFade direction="up">
          <MentorsSection />
        </InViewFade>
      </>
    </>
  );
};

export default MentorShip;
